var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValorMedio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_500_534)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 18C22.4768 18 18 22.4768 18 28C18 33.5232 22.4768 38 28 38C33.5232 38 38 33.5232 38 28C38 22.4768 33.5232 18 28 18ZM20 28C20 23.5814 23.5814 20 28 20C32.4186 20 36 23.5814 36 28C36 32.4186 32.4186 36 28 36C23.5814 36 20 32.4186 20 28ZM29 23.5C29 22.9477 28.5523 22.5 28 22.5C27.4477 22.5 27 22.9477 27 23.5V24H26.5C25.1193 24 24 25.1193 24 26.5C24 27.8807 25.1193 29 26.5 29H29.5C29.7761 29 30 29.2239 30 29.5C30 29.7761 29.7761 30 29.5 30H28H25C24.4477 30 24 30.4477 24 31C24 31.5523 24.4477 32 25 32H27V32.5C27 33.0523 27.4477 33.5 28 33.5C28.5523 33.5 29 33.0523 29 32.5V32H29.5C30.8807 32 32 30.8807 32 29.5C32 28.1193 30.8807 27 29.5 27H26.5C26.2239 27 26 26.7761 26 26.5C26 26.2239 26.2239 26 26.5 26H28H31C31.5523 26 32 25.5523 32 25C32 24.4477 31.5523 24 31 24H29V23.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_500_534",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValorMedio);
export default __webpack_public_path__ + "static/media/valor_medio.ff045fc76c7f4667d7a3b73cbf23a56b.svg";
export { ForwardRef as ReactComponent };